import './App.css';
import { useState , useEffect } from 'react';
import Nav from './components/Nav';
import Filter from './components/Filter';
import Cards from './components/Cards';
import {apiUrl, filterData} from './data';
import Spinner from './components/Spinner';
// function App() {
//   const [text, setText] = useState("");
//   function textHandler(e){
//     setText(e.target.value);
//   }


// //   // first render
// // useEffect(()=>{
// //   console.log("us");
// // },[]);

// //   // every render
// // useEffect(()=>{
// //   console.log("us");
// // });

// // only when text is changed
// // useEffect(()=>{
// //   console.log("change observerd in text");
// // },[text]);


// useEffect(()=>{

//   console.log("lisnner added");
//   return ()=>{
//     console.log("listener removed")
//   }
// },[text]);


//   return (
//     <div className="App">
//       <input type="text"  onChange={textHandler}/>
//     </div>
//   );
// }




function App() {
  const [couses, setCouses] = useState(null);
const [loading, setLoading] = useState(true);

const [cat, setCat] = useState(filterData[1].title);
  async function fetchData(){
    setLoading(true);
    try{
      const result = await fetch(apiUrl);
      const data = await result.json();

      console.log("value updated");
      setCouses(data.data); 
      setLoading(false);
    }
    catch(e){
      console.log("failed to featch");
    }
  }

  useEffect(()=>{
 fetchData();
},[])

return(
  <div className='min-h-screen flex flex-col bg-gray-700'>
    <div className='bg-bgDark w-full'>
    <Nav></Nav>
    </div>
    <Filter data ={filterData}
    cat = {cat}
    setCat = {setCat}
    />
    <div className='w-11/12  max-w-[1200px] mx-auto flex flex-wrap justify-center
    items-center'>
      { loading ? <Spinner/>  : <Cards
       courses = {couses}
       cat = {cat}
       />  }
    </div>
  </div>
);
}
export default App;
